<template>
    <q-dialog v-model="toggleHistoricDialog" persistent>
        <q-card class="historic-component" style="width: 800px; max-width: 80vw;">
            <q-card-section class="historic-component-section">
                <div class="text-h6">
                    <div class="header-form">
                        <div>Historial de Registro</div>
                        <div>
                            <q-btn class="q-mr-sm historic-component-btn" color="primary" icon="download"
                                @click="onExportHistoric">
                                <q-tooltip>Exportar Historial</q-tooltip>
                            </q-btn>
                            <q-btn class="historic-component-btn" color="negative" icon="close" v-close-popup>
                                <q-tooltip>Cerrar ventana</q-tooltip>
                            </q-btn>
                        </div>
                    </div>
                </div>
            </q-card-section>
            <q-card-section class="historic-component-section container">
                <div>
                    <div class="historic-component-subtitle">Datos de Creación</div>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <p>{{ historic_data.admin_created }}</p>
                        </div>
                        <div class="col-12 col-md-6">
                            <p>{{ date_created }}</p>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="historic-component-subtitle">Datos última modificación</div>
                    <div class="row">
                        <div v-if="!historic_data.admin_updated" class="col-12">
                            <p>No existen datos de actualización</p>
                        </div>
                        <div v-if="historic_data.admin_updated" class="col-12 col-md-6">
                            <p>{{ historic_data.admin_updated }}</p>
                        </div>
                        <div v-if="historic_data.admin_updated" class="col-12 col-md-6">
                            <p>{{ date_updated }}</p>
                        </div>
                    </div>
                </div>

                <q-btn flat color="primary" :label="label_details" @click="toggleDetails" />

                <div v-if="toggle_details" class="row">
                    <div class="col-12 col-md q-pa-sm historic-component-container">
                        <q-toggle class="historic-component-toggle" v-model="is_historic" color="primary"
                            label="Histórico" :dense="true" @update:model-value="toggleHistoricDetails" />
                    </div>
                    <div class="col-12 col-md q-pa-sm">
                        <DatePickerComponent :disable="is_historic" :clear="resetData" @date_selected="selectDate" />
                    </div>
                    <div class="col-12 col-md q-pa-sm">
                        <AdministratorAutocompleteComponent :disable="is_historic" :clear="resetData"
                            @administrator_selected="administratorSelected" />
                    </div>
                    <div class="col-12 col-md q-pa-sm">
                        <TypeOperationSelectComponent :disable="is_historic" :clear="resetData"
                            @type_operation_selected="typeOperationSelected" />
                    </div>
                    <div class="col-12 col-md">
                        <filter-button-component @onSearch="onSearch" @onReset="onReset" :enableOrderBtn="false" />
                    </div>
                </div>

                <div v-if="toggle_details" class="row">
                    <div class="col">
                        <table-component :loading="loading" :tableStyle="TableStyle.SUBSERVICE"
                            :enableVirtualScroll="true" :enablePagination="false" />
                    </div>
                </div>

                <q-card-actions align="center">
                    <q-btn label="Cancelar" color="negative" @click="cancelOption" v-close-popup />
                </q-card-actions>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script lang="ts">
import HistoricModalComponent from './HistoricModalComponent';
export default HistoricModalComponent;
</script>

<style lang="scss" src="./HistoricModalComponent.scss"></style>